import { useState, useEffect } from "react";
const API_ENDPOINT = `https://serene-sands-73553.herokuapp.com/https://aoe2.net/leaderboard/aoe2de/rm-1v1?start=0&length=100&search%5Bregex%5D=false&search%5Bvalue%5D=`;

const useFetch = (urlParams) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({ show: false, msg: "" });
  const [data, setData] = useState(null);
  const fetchPlayers = async (url) => {
    setIsLoading(true);
    try {
      const response = await fetch(url);
      const respBody = await response.json();

      if (respBody && respBody.recordsFiltered > 0) {
        setData(respBody.data);

        setError({ show: false, msg: "" });
      } else {
        console.log(JSON.stringify(respBody));
        setError({ show: true, msg: "No results" });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (urlParams.length > 3) {
      fetchPlayers(`${API_ENDPOINT}${urlParams}`);
    }
  }, [urlParams]);
  return { isLoading, error, data };
};

export default useFetch;
